import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PageHeader, Card, Empty, Spinner } from "@/components/UIKit";
import StatusBadge from "@/components/StatusBadge";
import { fmtNOK, fmtDate, contractTypeLabel } from "@/lib/format";
import { Link } from "react-router-dom";
import { NyAvtaleButton } from "@/components/NyAvtaleDialog";

export default function Avtaler() {
  const [items, setItems] = useState(null);
  const [total, setTotal] = useState(0);
  const [type, setType] = useState("");
  const [status, setStatus] = useState("");
  const [reload, setReload] = useState(0);

  useEffect(() => {
    (async () => {
      setItems(null);
      const params = new URLSearchParams({ limit: "200" });
      if (type) params.set("type", type);
      if (status) params.set("status", status);
      const { data } = await api.get(`/contracts?${params}`);
      setItems(data.items); setTotal(data.total);
    })();
  }, [type, status, reload]);

  const types = ["", "spot_paaslag", "spot", "fastpris", "variabel", "norgespris", "bedrift"];

  return (
    <div data-testid="avtaler-page">
      <PageHeader title="Avtaler" subtitle={`${total} avtaler i systemet`} actions={<NyAvtaleButton onCreated={() => setReload((r) => r + 1)} />} />

      <div className="flex items-center gap-2 mb-4 flex-wrap">
        <div className="flex items-center gap-1 bg-zinc-900/60 rounded-md p-1 border border-zinc-900">
          {types.map((t) => (
            <button key={t || "all"} onClick={() => setType(t)}
              className={`px-2.5 py-1 rounded text-xs transition-colors ${
                type === t ? "bg-zinc-800 text-zinc-100" : "text-zinc-500 hover:text-zinc-200"
              }`}
              data-testid={`type-${t || "all"}`}
            >
              {t ? contractTypeLabel(t) : "Alle typer"}
            </button>
          ))}
        </div>
        <div className="flex items-center gap-1 bg-zinc-900/60 rounded-md p-1 border border-zinc-900">
          {["", "aktiv", "utkast", "avsluttet", "oppsagt"].map((s) => (
            <button key={s || "all"} onClick={() => setStatus(s)}
              className={`px-2.5 py-1 rounded text-xs transition-colors ${
                status === s ? "bg-zinc-800 text-zinc-100" : "text-zinc-500 hover:text-zinc-200"
              }`}
            >
              {s ? s : "Alle status"}
            </button>
          ))}
        </div>
      </div>

      <Card className="overflow-hidden">
        {items === null ? <div className="p-8"><Spinner /></div>
          : items.length === 0 ? <Empty title="Ingen avtaler" />
          : (
          <table className="w-full text-sm">
            <thead>
              <tr className="text-left text-[11px] uppercase tracking-wider text-zinc-500 bg-zinc-950/60 sticky top-0">
                <th className="py-2.5 px-4 font-medium">Avtalenr</th>
                <th className="py-2.5 px-4 font-medium">Kunde</th>
                <th className="py-2.5 px-4 font-medium">Type</th>
                <th className="py-2.5 px-4 font-medium">Fra</th>
                <th className="py-2.5 px-4 font-medium">Påslag</th>
                <th className="py-2.5 px-4 font-medium">Fastbeløp</th>
                <th className="py-2.5 px-4 font-medium">Fastpris</th>
                <th className="py-2.5 px-4 font-medium">Status</th>
              </tr>
            </thead>
            <tbody>
              {items.map((c) => (
                <tr key={c.id} className="border-t border-zinc-900 hover:bg-zinc-900/40" data-testid={`ctr-row-${c.contract_number}`}>
                  <td className="py-2.5 px-4 font-mono text-xs text-emerald-400">{c.contract_number}</td>
                  <td className="py-2.5 px-4">
                    <Link to={`/kunder/${c.customer_id}`} className="text-zinc-100 hover:text-emerald-400">
                      {c.customer?.full_name || "—"}
                    </Link>
                  </td>
                  <td className="py-2.5 px-4 text-zinc-100">{contractTypeLabel(c.type)}</td>
                  <td className="py-2.5 px-4 text-zinc-400">{fmtDate(c.start_date)}</td>
                  <td className="py-2.5 px-4 tabular-nums text-zinc-300">{c.markup_ore_per_kwh?.toFixed(2)} øre</td>
                  <td className="py-2.5 px-4 tabular-nums text-zinc-300">{fmtNOK(c.monthly_fee_nok)}</td>
                  <td className="py-2.5 px-4 tabular-nums text-zinc-300">{c.fixed_price_ore ? `${c.fixed_price_ore.toFixed(2)} øre` : "—"}</td>
                  <td className="py-2.5 px-4"><StatusBadge value={c.status} /></td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </Card>
    </div>
  );
}
